import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en contacto-page.tsx y se descarga aparte (code-split) — así visitar
// el home u otra página pública no baja el bundle de esta (ver mismo criterio en staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contacto",
  head: () => ({
    meta: seoMeta({
      title: "Agenda tu Clase de Calistenia — Calistenia Progresiva",
      description: "Agenda tu primera clase de calistenia en Santiago por WhatsApp. Ubicación, horarios y todos nuestros canales de contacto.",
      path: "/contacto",
    }),
    links: [canonicalLink("/contacto")],
  }),
  component: lazyRouteComponent(() => import("./contacto-page"), "ContactoPage"),
});
